import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography, Alert, notification } from 'antd';
import authService from 'services/auth.services';
import { ArrowLeftOutlined } from '@ant-design/icons';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setIsLoading(true);
      await authService.resetPassword(values.email);
      setIsLoading(false);
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Lütfen mailinize gelen yönergeleri takip ediniz.',
      });
      navigate('/login');
    } catch (err) {
      setIsLoading(false);
      setError(err.message || 'Bir hata oluştu.');
      notification.error({
        message: 'İşlem Başarısız',
        description: err.message || 'Bir hata oluştu.',
      });
    }
  };

  return (
    <div className="register-page flex-row align-items-center">
      <div className="register-card">
        <div className="register-form-wrapper">
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Typography.Title level={4} className="register-title">
              <NavLink to="/login">
                <span className="back-icon">
                  <ArrowLeftOutlined />
                </span>
              </NavLink>
              Paye Kart Şifre Sıfırlama
            </Typography.Title>
            <Form.Item
              name="email"
              label="E-Mail"
              rules={[
                { required: true, message: 'Zorunlu Alan' },
                { type: 'email', message: 'Geçersiz mail adresi!' },
              ]}
            >
              <Input className="input__default" placeholder="E-Mail" type="email" />
            </Form.Item>
            {error && (
              <Form.Item>
                <Alert message={error} type="error" showIcon />
              </Form.Item>
            )}
            <Form.Item className="float-right">
              <Button
                className="button button__fill"
                type="primary"
                htmlType="submit"
                disabled={isLoading}
                loading={isLoading}
              >
                GÖNDER
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
